import { render } from "./editRelated.vue?vue&type=template&id=7efae6f9&scoped=true"
import script from "./editRelated.vue?vue&type=script&lang=js"
export * from "./editRelated.vue?vue&type=script&lang=js"

import "./editRelated.vue?vue&type=style&index=0&id=7efae6f9&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7efae6f9"],['__file',"src/views/exhibitionManage/components/editRelated.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7efae6f9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7efae6f9', __exports__)) {
    console.log('reload')
    api.reload('7efae6f9', __exports__)
  }
  
  module.hot.accept("./editRelated.vue?vue&type=template&id=7efae6f9&scoped=true", () => {
    console.log('re-render')
    api.rerender('7efae6f9', render)
  })

}


export default __exports__